export function getdata() {
	var obj = {
		headDataI: [{
				title: "操作",
				prop: "cz",
				width: "150px",
				custom: true,
			},
			{
				title: "应税消费品名称",
				prop: "xfs_3_x_1",
				width: "150px",
				custom: true,
			},
			{
				title: "减（免）性质代码",
				prop: "xfs_3_x_2.1",
				width: "150px",
				custom: true,
			},
			{
				title: "减（免）项目名称",
				prop: "xfs_3_x_2.2",
				width: "150px",
				custom: true,
			},
			{
				title: "减（免）税销售额",
				prop: "xfs_3_x_4",
				width: "150px",
				custom: true,
			},
			{
				title: "适用税率（从价定率）",
				prop: "xfs_3_x_5",
				width: "150px",
				custom: true,
			},
			{
				title: "减（免）税销售数量",
				prop: "xfs_3_x_6",
				width: "150px",
				custom: true,
			}, {
				title: "适用税率（从量定额）",
				prop: "xfs_3_x_7",
				width: "150px",
				custom: true,
			}, {
				title: "减（免）税额",
				prop: "xfs_3_x_8",
				width: "150px",
				custom: true,
			},
		],

		tableDataI: [{
			disablednoty_0_x_tes1: false,
			disablednoty_0_x_tes2: false,
			disablednoty_0_x_tes3: false,
			disablednoty_0_x_tes4: false,
			disablednoty_0_x_tes5: false,
			disablednoty_0_x_tes6: false,
			disablednoty_0_x_tes7: false,
			disablednoty_0_x_tes8: false,
			tes1: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes2: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes3: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes4: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes5: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes6: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes7: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},

		}, {
			disablednoty_0_x_tes1: false,
			disablednoty_0_x_tes2: false,
			disablednoty_0_x_tes3: false,
			disablednoty_0_x_tes4: false,
			disablednoty_0_x_tes5: false,
			disablednoty_0_x_tes6: false,
			disablednoty_0_x_tes7: false,
			disablednoty_0_x_tes8: false,
			tes1: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes2: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes3: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes4: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes5: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes6: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes7: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},

		}, {
			disablednoty_0_x_tes1: false,
			disablednoty_0_x_tes2: false,
			disablednoty_0_x_tes3: false,
			disablednoty_0_x_tes4: false,
			disablednoty_0_x_tes5: false,
			disablednoty_0_x_tes6: false,
			disablednoty_0_x_tes7: false,
			disablednoty_0_x_tes8: false,
			tes1: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes2: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes3: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes4: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes5: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes6: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes7: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},

		}, {
			disablednoty_0_x_tes1: false,
			disablednoty_0_x_tes2: false,
			disablednoty_0_x_tes3: false,
			disablednoty_0_x_tes4: false,
			disablednoty_0_x_tes5: false,
			disablednoty_0_x_tes6: false,
			disablednoty_0_x_tes7: false,
			disablednoty_0_x_tes8: false,
			tes1: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes2: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes3: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes4: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes5: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes6: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes7: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},

		}, ],
		option: [{
			label: "0002039901|SXA031900231|横琴、平潭区内企业销售货物免征消费税|《财政部 海关总署 国家税务总局关于横琴 平潭开发有关增值税和消费税政策的通知》 财税〔2014〕51号第二条",
			value: "0002039901",
			name: "横琴、平潭区内企业销售货物免征消费税"
		}, {
			label: "0002061003|SXA031900249|节能环保电池免税|《财政部　国家税务总局关于对电池 涂料征收消费税的通知》 财税〔2015〕16号第二条第一款",
			value: "0002061003",
			name: "节能环保电池免税"
		}, {
			label: "0002061004|SXA031900250|节能环保涂料免税|《财政部　国家税务总局关于对电池 涂料征收消费税的通知》 财税〔2015〕16号第二条第三款",
			value: "0002061004",
			name: "节能环保涂料免税"
		}, {
			label: "0002064001|SXA031900129|废动植物油生产纯生物柴油免税|《财政部 国家税务总局关于对利用废弃的动植物油生产纯生物柴油免征消费税的通知》 财税〔2010〕118号第一条",
			value: "0002064001",
			name: "废动植物油生产纯生物柴油免税"
		}, {
			label: "0002064005|SXA031900526|用废矿物油生产的工业油料免税|《财政部 税务总局关于继续对废矿物油再生油品免征消费税的公告》 财政部 税务总局公告2023年第69号",
			value: "0002064005",
			name: "用废矿物油生产的工业油料免税"
		}, {
			label: "0002102901|SXA031900891|对北京冬奥组委、北京冬奥会测试赛赛事组委会赛后再销售物品和出让资产收入免征消费税|《财政部 税务总局 海关总署关于北京2022年冬奥会和冬残奥会税收政策的通知》 财税〔2017〕60号第一条第（八）款",
			value: "0002102901",
			name: "对北京冬奥组委、北京冬奥会测试赛赛事组委会赛后再销售物品和出让资产收入免征消费税"
		}, {
			label: "0002102902|SXA031900892|对北京冬奥组委、北京冬奥会测试赛赛事组委会委托加工生产的高档化妆品免征消费税|《财政部 税务总局 海关总署关于北京2022年冬奥会和冬残奥会税收政策的通知》 财税〔2017〕60号第一条第（十二）款",
			value: "0002102902",
			name: "对北京冬奥组委、北京冬奥会测试赛赛事组委会委托加工生产的高档化妆品免征消费税"
		}, {
			label: "0002102903|SXA031900901|对国际奥委会取得的与北京2022年冬奥会有关的收入免征消费税|《财政部 税务总局 海关总署关于北京2022年冬奥会和冬残奥会税收政策的通知》 财税〔2017〕60号第二条第（一）款",
			value: "0002102903",
			name: "对国际奥委会取得的与北京2022年冬奥会有关的收入免征消费税"
		}, {
			label: "0002102904|SXA031900905|对中国奥委会取得的由北京冬奥组委支付的收入免征消费税|《财政部 税务总局 海关总署关于北京2022年冬奥会和冬残奥会税收政策的通知》 财税〔2017〕60号第二条第（四）款",
			value: "0002102904",
			name: "对中国奥委会取得的由北京冬奥组委支付的收入免征消费税"
		}, {
			label: "0002102905|SXA031900909|对国际残奥委会取得的与北京2022年冬残奥会有关的收入免征消费税|《财政部 税务总局 海关总署关于北京2022年冬奥会和冬残奥会税收政策的通知》 财税〔2017〕60号第二条第（五）款",
			value: "0002102905",
			name: "对国际残奥委会取得的与北京2022年冬残奥会有关的收入免征消费税"
		}, {
			label: "0002102906|SXA031900913|对中国残奥委会取得的由北京冬奥组委分期支付的收入免征消费税|《财政部 税务总局 海关总署关于北京2022年冬奥会和冬残奥会税收政策的通知》 财税〔2017〕60号第二条第（六）款",
			value: "0002102906",
			name: "对中国残奥委会取得的由北京冬奥组委分期支付的收入免征消费税"
		}, {
			label: "0002102907|SXA031901107|对赞助商、供应商、特许商及其分包商根据协议向北京冬奥组委提供指定货物或服务，免征消费税|《财政部 税务总局 海关总署关于北京2022年冬奥会和冬残奥会税收优惠政策的公告》 财政部公告2019年第92号第三条",
			value: "0002102907",
			name: "对赞助商、供应商、特许商及其分包商根据协议向北京冬奥组委提供指定货物或服务，免征消费税"
		}, {
			label: "0002125204|SXA031900389|生产成品油过程中消耗的自产成品油部分免税|《财政部 国家税务总局关于对成品油生产企业生产自用油免征消费税的通知》 财税〔2010〕98号第一条",
			value: "0002125204",
			name: "生产成品油过程中消耗的自产成品油部分免税"
		}, {
			label: "0002125205|SXA031900589|自产石脑油、燃料油生产乙烯、芳烃产品免税|《财政部 国家税务总局关于延续执行部分石脑油燃料油消费税政策的通知》 财税〔2011〕87号第二条",
			value: "0002125205",
			name: "自产石脑油、燃料油生产乙烯、芳烃产品免税"
		}, {
			label: "0002125207|SXA031900527|用已税汽油生产的乙醇汽油免税|《财政部 国家税务总局关于提高成品油消费税税率后相关成品油消费税政策的通知》 财税〔2008〕168号第四条",
			value: "0002125207",
			name: "用已税汽油生产的乙醇汽油免税"
		}, {
			label: "0002125208|SXA031901251|外购石脑油、燃料油生产乙烯、芳烃产品退税|《财政部 中国人民银行 国家税务总局关于延续执行部分石脑油燃料油消费税政策的通知》(财税〔2011〕87号)",
			value: "0002125208",
			name: "外购石脑油、燃料油生产乙烯、芳烃产品退税"
		}, {
			label: "0002125209|SXA031901322|按照定点直供计划销售自产石脑油、燃料油免征消费税|《国家税务总局关于发布<用于生产乙烯、芳烃类化工产品的石脑油、燃料油退（免）消费税暂行办法>的公告》 国家税务总局公告2012年第36号第十七条",
			value: "0002125209",
			name: "按照定点直供计划销售自产石脑油、燃料油免征消费税"
		}, {
			label: "0002129999|SXA031999999|其他|其他",
			value: "0002129999",
			name: "其他"
		}]
	}
	return obj
}